import { gql } from '@apollo/client';

export const CHECKLIST_DELETED = gql`
  subscription checklistDeleted {
    checklistDeleted {
      requiredDocumentId
    }
  }
`;
